<template>
  <div class="special-sale">
    <navbar ref="navbar" show-home title="会员特卖专场" />
    <div class="special-sale-container">
      <cont-nav :nav-height="navbarHeight" :nav-list="navList" ref="contNav" />
    </div>
    <back-top show-back />
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import BackTop from '../components/BackToTop'
import ContNav from '../components/specialSale/SpecialSaleNav'
export default {
  name: 'specialSale',
  components: {
    Navbar,
    ContNav,
    BackTop
  },
  data () {
    return {
      navbarHeight: 44,
      navList: []
    }
  },
  mounted () {
    this.navbarHeight = this.$refs.navbar.navbarHeight
    this.getSpecialSaleNav().then(() => {
      this.$refs.contNav.getGoodsListHandler(this.navList[0].id, 1)
      // this.$refs.contNav.navItemBanner = this.navList[0].img_url
    })
  },
  methods: {
    async getSpecialSaleNav () {
      const res = await this.$axios.get('api/act/anl')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.navList = data
        } else if (code === 9006) {

        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.special-sale-container {
  width: 100%;
  height: 100%;
  background: url("../assets/img/special-sale/bg.png") top no-repeat;
  background-size: 100% 3.26rem;
}
</style>
